import React from 'react';
import { ActivityIcon, AlertTriangleIcon, FrownIcon, PillIcon, TimerIcon, TrendingDownIcon } from 'lucide-react';
import { Section } from '../Section';
import { TransformCTA } from '../TransformCTA';
const items = [{
  Icon: ActivityIcon,
  title: 'You see an elevated creatinine',
  body: 'And the first question is: “Where do I start?” You need to interpret the finding in context, identify what information matters, and determine the appropriate next step.'
}, {
  Icon: TimerIcon,
  title: 'What should take minutes consumes the visit',
  body: 'You know the information exists. But you have to search for it, cross-reference it, and organize it yourself while the patient is waiting.'
}, {
  Icon: PillIcon,
  title: 'Every medication creates another question',
  body: 'Kidney function changes. Now you need to review the medication context and determine what needs to be assessed before making a treatment decision.'
}, {
  Icon: AlertTriangleIcon,
  title: 'An abnormal potassium changes the consultation',
  body: 'You see the result. Now you need to organize the assessment, review relevant factors, determine what requires attention, and establish the escalation pathway.'
}, {
  Icon: TrendingDownIcon,
  title: 'You’re not sure whether there is true progression',
  body: 'Another laboratory result comes back. The number has changed. But how should the change be interpreted in the broader clinical context?'
}, {
  Icon: FrownIcon,
  title: 'The patient leaves. The uncertainty stays.',
  body: 'You don’t necessarily need more information. You need a better way to navigate the information you already have.'
}];
export function SoundsFamiliar() {
  return <Section tone="white" eyebrow="Does this sound familiar?" title="Do any of these situations happen during your practice?" subtitle="If you answered “yes” to even one of them, Renal Decision Desk™ was created for you." data-id="element-248" data-mp="2otqmcafx35ce">
      <ul className="grid gap-3.5 sm:grid-cols-2 sm:gap-4" data-id="element-249" data-mp="mgb2f2ijua17">
        {items.map(({
        Icon,
        title,
        body
      }) => <li key={title} className="flex gap-3.5 rounded-2xl border border-ink-line bg-cream p-5" data-id="element-250" data-mp="hjb4jevusdl6">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-ink" data-id="element-251" data-mp="wd7d9evx788x">
              <Icon className="h-5 w-5 text-cyan-brand" aria-hidden="true" data-id="element-252" data-mp="rijuzxrifa2s" />
            </span>
            <div data-id="element-253" data-mp="15dvnrzm3uqh2">
              <h3 className="text-[15px] font-extrabold uppercase leading-snug tracking-tight text-ink" data-id="element-254" data-mp="10gvi3pt63pqh">
                {title}
              </h3>
              <p className="mt-1.5 text-[14px] leading-relaxed text-ink-soft" data-id="element-255" data-mp="1f4gmro5oxx0i">
                {body}
              </p>
            </div>
          </li>)}
      </ul>

      <TransformCTA label="Yes — this is exactly my problem" sub="Get the decision routes for all of these scenarios • Instant access" data-id="element-256" data-mp="1o5y6dgib4gty" />
    </Section>;
}